import React from 'react';

function InputField(props) {
  const {
    isEmail,
    minLength,
    pattern,
    max,
    min,
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    onChange,
    name,
    value,
    maxLength,
    readOnly,
  } = props;

  // Dark mode styling for all default icons
  const noSpinButtonStyles = `
  [&::-webkit-outer-spin-button]:appearance-none 
  [&::-webkit-inner-spin-button]:appearance-none 
  [&::-webkit-inner-spin-button]:m-0 
  [&::-webkit-outer-spin-button]:m-0 
  [&[type='number']]:moz-appearance-textfield
`;

  const darkModeIconClasses = `
    [&::-webkit-calendar-picker-indicator]:dark:brightness-0 
    [&::-webkit-calendar-picker-indicator]:dark:invert 
    [&::-webkit-calendar-picker-indicator]:dark:saturate-0
    [&::-webkit-clear-button]:dark:brightness-0 
    [&::-webkit-clear-button]:dark:invert 
    [&::-webkit-clear-button]:dark:saturate-0
    [&::-webkit-inner-spin-button]:dark:brightness-0 
    [&::-webkit-inner-spin-button]:dark:invert 
    [&::-webkit-inner-spin-button]:dark:saturate-0
    [&::-webkit-outer-spin-button]:dark:brightness-0 
    [&::-webkit-outer-spin-button]:dark:invert 
    [&::-webkit-outer-spin-button]:dark:saturate-0
    [&::-webkit-search-cancel-button]:dark:brightness-0 
    [&::-webkit-search-cancel-button]:dark:invert 
    [&::-webkit-search-cancel-button]:dark:saturate-0
  `;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === 'auth' ? 'ml-1.5 font-medium' : 'ml-3 font-bold'
        }`}
      >
        {label}
      </label>
      <input
        minLength={minLength}
        pattern={isEmail ? '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$' : pattern}
        max={max}
        min={min}
        readOnly={readOnly}
        maxLength={maxLength}
        onChange={onChange}
        name={name}
        value={value}
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none 
          ${
            disabled === true
              ? '!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]'
              : state === 'error'
              ? 'border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400'
              : state === 'success'
              ? 'border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400'
              : 'border-gray-200 dark:!border-white/10 dark:text-white'
          } 
          dark:placeholder:text-white/50
           ${noSpinButtonStyles} 
          ${darkModeIconClasses}
        `}
        onFocus={(e) =>
          e.target.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        } //time
        onWheel={(e) => e.target.blur()}
      />
    </div>
  );
}

export default InputField;
